import { createAction, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { AgentTransactionDetailResponse } from '../models/agent-transaction-detail.model';
import { TaxInvoiceDetailResponse } from '../models/tax-invoice-detail.model';
import { TaxInvoiceListContent, TaxInvoiceListSearchCriteria } from '../models/tax-invoice-list.model';

export const taxInvoiceAction = {
  taxInvoiceListRequest: createAction(
    '[Tax Invoice] tax invoice list request',
    props<{ payload: TaxInvoiceListSearchCriteria }>()
  ),
  taxInvoiceListResponse: createAction(
    '[Tax Invoice] tax invoice list response',
    props<{ response: Pagination<TaxInvoiceListContent> }>()
  ),
  taxInvoiceListReset: createAction('[Tax Invoice] tax invoice list reset'),
  viewTaxInvoiceRequest: createAction('[Tax Invoice] tax invoice detail request', props<{ receiptNo: string }>()),
  viewTaxInvoiceResponse: createAction(
    '[Tax Invoice] tax invoice detail response',
    props<{ response: TaxInvoiceDetailResponse }>()
  ),
  viewAgentTransactionRequest: createAction(
    '[Tax Invoice] agent transaction detail request',
    props<{ receiptNo: string }>()
  ),
  viewAgentTransactionResponse: createAction(
    '[Tax Invoice] agent transaction detail response',
    props<{ response: AgentTransactionDetailResponse }>()
  )
};
